<nav mat-tab-nav-bar class="tab-custom-overflow">
  @if (showStatusMenuItem) {
    <a
      mat-tab-link
      [routerLink]="['/opfoelgning/dashboard']"
      routerLinkActive="active"
      routerLinkActiveOptions="{exact:true}"
      [class.padding--right-l]="antalAftaleOpfoelgninger > 0"
      >
      Overblik
    </a>
  }
  <a
    mat-tab-link
    [routerLink]="['/opfoelgning/aftale']"
    routerLinkActive="active"
    routerLinkActiveOptions="{exact:true}"
    [class.padding--right-l]="antalAftaleOpfoelgninger > 0"
    >
    <span
      [matBadge]="antalAftaleOpfoelgninger"
      matBadgeSize="small"
      matBadgeOverlap="false"
      [matBadgeHidden]="!(antalAftaleOpfoelgninger > 0)"
      >
      Serviceaftaler
    </span>
  </a>
  <a
    mat-tab-link
    [routerLink]="['/opfoelgning/ordre']"
    routerLinkActive="active"
    routerLinkActiveOptions="{exact:true}"
    [class.padding--right-l]="antalOrdreOpfoelgninger > 0"
    >
    <span
      [matBadge]="antalOrdreOpfoelgninger"
      matBadgeSize="small"
      matBadgeOverlap="false"
      [matBadgeHidden]="!(antalOrdreOpfoelgninger > 0)"
      >
      Serviceordrer
    </span>
  </a>
</nav>
